import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';

type MunilyCheckboxType = 'bullet' | 'check_box' | 'check_circle';

@Component({
  selector: 'app-checkbox-playground',
  templateUrl: './checkbox-playground.component.html',
  styleUrls: ['./checkbox-playground.component.scss'],
})
export class CheckboxPlaygroundComponent {
  // Nota: `app-common-checkbox` soporta CVA, así que lo podemos bindear con FormControl.
  readonly control = new FormControl(false);

  type: MunilyCheckboxType = 'check_box';
  indeterminate = false;
  disabled = false;
  labelKey = 'Marca tu checkbox';
  labelPosition: 'before' | 'after' = 'after';

  customClass = '';

  lastEvent = '';

  readonly types: MunilyCheckboxType[] = ['check_box', 'check_circle', 'bullet'];
  readonly positions = ['before', 'after'] as const;

  onChange(v: boolean): void {
    this.lastEvent = `change: ${v} @ ${new Date().toLocaleTimeString()}`;
  }

  toggleValue(): void {
    this.control.setValue(!this.control.value);
  }
}

